/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostRegisterFirstClipSuccessResponse
 */
export interface PostRegisterFirstClipSuccessResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof PostRegisterFirstClipSuccessResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof PostRegisterFirstClipSuccessResponse
     */
    message: string;
}

export function PostRegisterFirstClipSuccessResponseFromJSON(json: any): PostRegisterFirstClipSuccessResponse {
    return PostRegisterFirstClipSuccessResponseFromJSONTyped(json, false);
}

export function PostRegisterFirstClipSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostRegisterFirstClipSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function PostRegisterFirstClipSuccessResponseToJSON(value?: PostRegisterFirstClipSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

